import { cellStyle } from "../../../components/Table/Table.styles";
import { Role } from "../../../services/api/types/Roles";
import { roundToTwo } from "../../../services/utils/roundToTwo";

// define your dropdown filters
export const defaultDropDownFilters = {
  status: {
    id: 2,
    title: "Status",
    options: [],
    enum: true,
    enumOptions: ["Inactive", "Active"],
  },
};

// define your columns
export const getColumns = () => {
  return [
    {
      title: "Role",
      field: "name",
      cellStyle: cellStyle,
    },
    {
      title: "Members",
      field: "members",
      type: "numeric",
      align: "left",
      searchable: false,
      cellStyle: cellStyle,
      customFilterAndSearch: null,
      render: (role: Role) => {
        return roundToTwo(parseFloat(role.members as unknown as string));
      },
    },
    {
      title: "Status",
      field: "status",
      searchable: false,
      cellStyle: cellStyle,
      render: (role: any) => {
        return <>{role.status === 1 ? "Active" : "Inactive"}</>;
      },
      customFilterAndSearch: (value: any, rowData: any) => {
        if (value[value.length - 1] === "any") {
          return rowData;
        } else {
          return value.indexOf(rowData.status) > -1;
        }
      },
    },
    {
      title: "Description",
      field: "description",
      searchable: false,
      cellStyle: cellStyle,
      customFilterAndSearch: null,
    },
    {
      title: "Created",
      field: "createdAt",
      searchable: false,
      align: "left",
      cellStyle: cellStyle,
      render: (role: any) => {
        return (
          <>
            {new Date(role.createdAt.slice(0, 10)).toLocaleDateString("en-US")}
          </>
        );
      },
      customFilterAndSearch: null,
    },
    {
      title: "Modified",
      field: "updatedAt",
      searchable: false,
      align: "left",
      cellStyle: cellStyle,
      render: (role: any) => {
        return (
          <>
            {new Date(role.updatedAt.slice(0, 10)).toLocaleDateString("en-US")}
          </>
        );
      },
      customFilterAndSearch: null,
    },
  ];
};
